export default __webpack_public_path__ + "static/media/pug-say-what.bea5ad4e.gif";